import { useQuery } from '@tanstack/react-query';
import { Link as RouterLink, useParams, useSearchParams } from 'react-router-dom';
import { Alert, Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material';
import { endpoints, qk } from '../api/endpoints';
import { JobView, jobKind } from '../components/JobView';
import { SectionCard } from '../components/common';

export function JobPage() {
  const id = Number(useParams().id);
  const [params] = useSearchParams();
  const fresh = params.get('fresh') === '1';
  const job = useQuery({ queryKey: qk.job(id), queryFn: () => endpoints.job(id) });
  const cloneId = job.data?.cloneId ?? null;
  const clone = useQuery({ queryKey: qk.clone(cloneId ?? 0), queryFn: () => endpoints.clone(cloneId!), enabled: !!cloneId });

  return (
    <Stack spacing={2}>
      <Breadcrumbs>
        {clone.data ? (
          <Link component={RouterLink} to={`/clones/${clone.data.id}/jobs`} underline="hover" color="text.secondary" variant="body2">
            {clone.data.name}
          </Link>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Jobs
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          job #{id}
        </Typography>
      </Breadcrumbs>
      {fresh && job.data && jobKind(job.data.type) === 'provision' && job.data.status !== 'succeeded' && (
        <Alert severity="info">
          Provisioning {clone.data?.domain ?? ''}. You can leave this page — the job keeps running on the server and the result stays in the clone's Jobs tab. Stay here to copy the super admin password when it's done.
        </Alert>
      )}
      <SectionCard>
        <JobView id={id} logHeight="max(320px, calc(100vh - 420px))" />
      </SectionCard>
      {clone.data && job.data?.status === 'succeeded' && (
        <Stack direction="row" spacing={1}>
          <Button variant="contained" component={RouterLink} to={`/clones/${clone.data.id}`}>
            Open {clone.data.name}
          </Button>
          {jobKind(job.data.type) === 'provision' && (
            <Button component={RouterLink} to={`/clones/${clone.data.id}/apps`}>
              Set up mobile apps
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
}
